import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import { EmptyContent } from 'components';
import { Link } from 'react-router-dom';
// import { ReactComponent as NotificationSvg } from 'assets/svg/notification-line.svg';
import { ReactComponent as CloseCircle } from 'assets/svg/close-circle-line.svg';
// import { EmptyContent } from './empty-content';

export const Notification = props => {
  // const [file, setFile] = useState();
  // const [preview, setPreview] = useState('');

  // const onSubmit = e => {
  //   e.preventDefault();
  // };

  // const onImageChange = e => {
  //   const image = e.target.files[0];
  //   setFile(image);
  //   setPreview(URL.createObjectURL(image));
  // };

  return (
    <div
      className={classnames('comments', {
        show: props.show
      })}
    >
      <div className="comments__left">
        <div className="comments__overlay" onClick={props.toggle} />
      </div>

      <div className="comments__side">
        <div className="modal__header modal__header--settings">
          <div className="modal__footer__item">
            <span className="modal__title--text">Notification</span>
          </div>
          <div className="modal__footer__item">
            <CloseCircle
              className=""
              style={{ cursor: 'pointer' }}
              onClick={props.toggle}
            />
          </div>
        </div>
        <div className="row">
          <EmptyContent notification />

          <div className="thread__container">
            <div className="thread__card">
              <div className="thread__card__group">
                <div className="thread__card__info">
                  <Link className="thread__avatar" to="/profile">
                    <img src="https://picsum.photos/200" alt="" />
                  </Link>

                  <div className="thread__username-container">
                    <div className="thread__username-inner">
                      <Link className="thread__username" to="/profile">
                        @dantelex
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
              <div className="thread__card__group">
                <div className="thread__card__body">
                  <p>
                    Lorem ipsum dolor sit amet consectetur, adipisicing elit.
                    Eveniet, assumenda.
                  </p>
                </div>
              </div>
              <div className="thread__card__group">
                <div className="thread__card__body thread__card__timeline thread__sub-item">
                  <div className="">2mins</div>
                  <div className="">March 29, 2019 at 3:10 PM</div>
                  <div className="">NightWatch</div>
                </div>
              </div>
            </div>
            <div className="thread__card">
              <div className="thread__card__group">
                <div className="thread__card__info">
                  <Link className="thread__avatar" to="/profile">
                    <img src="https://picsum.photos/200" alt="" />
                  </Link>

                  <div className="thread__username-container">
                    <div className="thread__username-inner">
                      <Link className="thread__username" to="/profile">
                        @dantelex
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
              <div className="thread__card__group">
                <div className="thread__card__body">
                  <p>
                    Lorem ipsum dolor sit amet consectetur, adipisicing elit.
                    Eveniet, assumenda.
                  </p>
                </div>
              </div>
              <div className="thread__card__group">
                <div className="thread__card__body thread__card__timeline thread__sub-item">
                  <div className="">2mins</div>
                  <div className="">March 29, 2019 at 3:10 PM</div>
                  <div className="">NightWatch</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

Notification.propTypes = {
  show: PropTypes.bool,
  toggle: PropTypes.func
};
